<template>
  <div>
    <transition
      name="custom-classes-transition"
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut">
      <!-- <div v-show="adDetails"
           class="adModal">
        <Ad
          v-if="adDetails"
          :id="adDetails"
          :opener="'modal'"
          @closeModal="closeModal" />
      </div> -->
    </transition>

    <!-- Match list item -->
    <article v-if="isReady" :id="match.depth + '-' + ad.id">
      <div v-for="(flat, index) in ad.flats"
           :key="flat.id"
           class="grid-x"
           :class="{hidden:match.available_as_direct}">
        <!-- Image -->
        <div v-show="match.available_as_direct" class="cell small-12 hiddeninfo">
          <p><strong>OBS</strong> - Denna bostad är även <a :href="'#direct' + '-' + ad.id">tillgänglig som direktbyte</a>.</p>
        </div>
        <div class="cell small-12 medium-shrink" :style="[flat.photos.length ? {background: 'url('+url(flat.photos[0]).card+')', backgroundSize: 'cover'} : {background:'url(/img/bild_saknas.jpg)', backgroundSize: 'cover'}]">
          <div class="image-wrap">
            <div v-if="flat.photos.length"
                 class="card-image-count">
              1/{{ flat.photos.length }}
            </div>
            <div v-if="ad.flats && ad.flats.length == index+1"
                 class="overlay">
              <div class="swap-type-name">
                {{ $t('match.'+match.depth) }}
              </div>
              <div class="swap-type">
                <template v-if="match.depth == 'direct'">
                  <svg xmlns="http://www.w3.org/2000/svg"
                       width="17"
                       height="14"><path fill="#ABABAB"
                                         fill-rule="evenodd"
                                         d="M.7827435 5.0000215c-.117187 0-.2167965-.0410157-.2988274-.1230466-.0820308-.0820309-.1230465-.1816404-.1230465-.2988274v-.2812494c0-.117187.0410157-.2167965.1230465-.2988274.0820309-.0820309.1816404-.1230466.2988274-.1230466h11.0780939V1.9062788c0-.328124.117187-.5976548.3515616-.8085918.2343746-.210937.5097644-.3164055.8261699-.3164055s.5800768.1289061.7910138.3867178l2.2499946 2.531244c.1874994.210937.2812493.4570302.2812493.7382795s-.0937499.5273425-.2812493.7382795l-2.2499946 2.531244c-.210937.2578117-.4746083.3867178-.7910138.3867178s-.5917953-.1054685-.8261699-.3164055c-.2343746-.210937-.3515616-.4804678-.3515616-.8085918V5.0000215H.7827435zm12.2030912-3.0937427v5.062488l2.2499946-2.531244-2.2499946-2.531244zm2.9531179 7.5937319c.1171871 0 .2167966.0410157.2988275.1230466.0820308.0820309.1230465.1816404.1230465.2988274v.2812494c0 .117187-.0410157.2167965-.1230465.2988274-.0820309.0820308-.1816404.1230465-.2988275.1230465H4.8608588v1.9687454c0 .328124-.117187.5976548-.3515616.8085918-.2343747.210937-.5097645.3164055-.8261699.3164055-.3164055 0-.5800768-.1289062-.7910138-.3867179L.6421189 10.8007889c-.1874994-.210937-.2812493-.4570302-.2812493-.7382795s.0937499-.5273425.2812493-.7382795l2.2499946-2.531244c.210937-.2578117.4746083-.3867178.7910138-.3867178.3164054 0 .5917952.1054685.8261699.3164055.2343746.210937.3515616.4804678.3515616.8085918v1.9687453h11.0780938zM3.7358615 12.5937534v-5.062488l-2.2499946 2.531244 2.2499946 2.531244z" /></svg>
                </template>
                <template v-if="match.depth == 'triangle'">
                  <svg xmlns="http://www.w3.org/2000/svg"
                       width="19"
                       height="19"><path fill="#ABABAB"
                                         fill-rule="evenodd"
                                         d="M5.9155438 4.8906515c-.0468747.0937499-.1289061.1523432-.2460932.1757808-.117187.0234376-.2226555 0-.3164055-.0703123l-.2460931-.1406247c-.09375-.0703123-.1523432-.1582027-.1757808-.2636712-.0234377-.1054685-.0117186-.2050775.0351561-.2988274L6.5131986 1.832065C6.9350726 1.1523793 7.5151494.68948963 8.2534289.44339646c.7382794-.24609316 1.4765589-.24609316 2.2148384 0 .7382795.24609317 1.3183563.70898284 1.7402303 1.38866854l1.6523398 2.6015563.421874-1.8281206c.0234376-.1171871.0820308-.2050775.1757808-.2636713.0937499-.0585938.1992184-.0761718.3164055-.0527342l.2812493.0703123c.1171871.0234376.2050775.0820309.2636713.1757809.0585937.0937499.0761718.1992184.0527342.3164054l-.7734356 3.3046797c-.0234377.117187-.0820309.2050774-.1757809.2636712-.0937499.0585938-.1992184.0761719-.3164055.0527343l-3.3046796-.7734357c-.117187-.0234376-.2050775-.0820309-.2636712-.1757808-.0585938-.09375-.0761719-.1992185-.0527343-.3164055l.0703123-.2812493c.0234377-.1171871.0820309-.2050775.1757809-.2636713.0937499-.0585938.1992184-.0761719.3164055-.0527342l1.8632768.421874-1.6523398-2.6015563c-.2812494-.4453117-.6679672-.7558576-1.1601535-.9316384-.4921863-.1757809-.9843727-.1757809-1.476559 0-.4921863.1757808-.8789042.4863267-1.1601535.9316384L5.9155438 4.8906515zm11.9179403 5.9413921c.4687487.7265609.632811 1.494137.4921864 2.3027289-.1406247.8085918-.521483 1.4882775-1.1425754 2.0390576C16.5620026 15.7246102 15.8295827 16 14.9858347 16h-3.6913975l1.3007782 1.3359343c.0937499.0703123.1406246.1640623.1406246.2812493 0 .1171871-.0468747.2226556-.1406246.3164055l-.1757808.1757809c-.09375.0937499-.1992185.1406246-.3164055.1406246-.1171871 0-.210937-.0468747-.2812494-.1406246l-2.3906193-2.3906193c-.0937499-.0703124-.1406246-.1640623-.1406246-.2812494 0-.117187.0468747-.210937.1406246-.2812493l2.3906193-2.3906193c.0703124-.0937499.1640623-.1406247.2812494-.1406247.117187 0 .2226555.0468748.3164055.1406247l.1757808.1757808c.0937499.09375.1406246.1992185.1406246.3164055 0 .1171871-.0468747.210937-.1406246.2812494l-1.3007782 1.3359343h3.6913975c.5624986 0 1.0488254-.1816404 1.4589809-.5449206.4101554-.3632802.6621076-.8144514.7558576-1.3535124.0937499-.539061-.0117186-1.054685-.3164055-1.5468713l-1.8632769-2.9882741c-.0468747-.09375-.0585937-.1992185-.0351561-.3164055.0234376-.1171871.0820309-.1992185.1757808-.2460932l.2460932-.1406247c.0937499-.0703123.1992184-.0937499.3164055-.0703123.117187.0234376.1992184.0820309.2460931.1757808l1.8632768 2.9882742zm-15.9960556.5976548c-.3046869.4921863-.4101554 1.0078103-.3164055 1.5468713.09375.539061.3457022.9902322.7558576 1.3535124.4101555.3632802.8964822.5449206 1.4589809.5449206h3.5156166c.1171871 0 .2167966.0410157.2988274.1230466.0820309.0820308.1230466.1816403.1230466.2988274v.2812493c0 .117187-.0410157.2167965-.1230466.2988274C7.4682747 15.9589843 7.3686652 16 7.2514781 16H3.7358615c-.843748 0-1.5761679-.2753898-2.1972604-.8261699C.9175087 14.62305.5366504 13.9433643.3960257 13.1347725c-.1406246-.8085919.0234376-1.576168.4921863-2.3027289l1.9687453-3.1288988-1.8632768.421874c-.117187.0234376-.2226555.0058595-.3164055-.0527343-.0937499-.0585938-.1523432-.1464842-.1757808-.2636712L.4311819 7.527364c-.0234376-.1171871-.0058596-.2226556.0527342-.3164055.0585938-.09375.1464842-.1523433.2636713-.1757809L4.052267 6.261742c.117187-.0234377.2226555-.0058596.3164055.0527342.0937499.0585938.1523432.1464842.1757808.2636713l.7734357 3.3046796c.0234376.117187.0058595.2226555-.0527343.3164055-.0585938.0937499-.1464842.1523432-.2636712.1757808l-.2812493.0703123c-.1171871.0234377-.2226556.0058596-.3164055-.0527342-.09375-.0585938-.1523432-.1464842-.1757809-.2636713l-.421874-1.8281206-1.9687453 3.1288988z" /></svg>
                </template>
              </div>
            </div>
            <img v-if="!flat.photos[0]"
                 :style="{opacity: 0}"

                 src="/img/bild_saknas.jpg">
            <img v-else
                 :style="{opacity: 0}"
                 :src="url(flat.photos[0]).card"
                 @error="noimage">
          </div>
        </div>

        <!-- Data -->
        <div class="cell small-12 medium-auto">
          <div class="card-info">
            <!-- Owner details -->
            <div class="grid-x">
              <div class="cell medium-12 large-4">
                <div class="card-location">
                  <p>{{ match.owner.firstname }} {{ match.owner.lastname }}</p>
                </div>
              </div>
              <div class="cell small-12 medium-6 large-4">
                <div class="card-location">
                  <!-- <p>{{ match.owner.email }}</p> -->
                  <p><a :href="'mailto:' + match.owner.email">{{ match.owner.email }}</a></p>
                </div>
              </div>
              <div class="cell small-12 medium-6 large-4">
                <div class="card-location">
                  <p>{{ match.owner.phone }}</p>
                </div>
              </div>
            </div>

            <div class="grid-x">
              <div class="cell small-12 large-auto">
                <div class="card-location">
                  <h2>{{ flat.street }} {{ flat.street_number }}</h2>
                  <h3 v-if="flat.hood">
                    {{ flat.city }}
                  </h3>
                  <h3 v-else>
                    {{ flat.city }}
                  </h3>
                </div>
              </div>



<!-- FLOOR -->

              <div class="cell small-6 large-shrink">
                <div class="card-data">
          <span class="nav-icon">
            <!-- <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="20">
              <path
                fill-rule="evenodd"
                d="M24.062443 0c.171874 0 .329426.064453.472655.1933589.143228.128906.214843.2936189.214843.4941395v14.867152c0 .2864579-.078776.5442698-.236328.7734357-.157551.2291659-.365233.4010405-.623045.5156237l-6.531234 2.2773384c-.572915.1718746-1.145831.1718746-1.718746 0L8.24998 16.4999607.94531 19.2069855c-.085937.0286459-.171874.0429686-.257812.0429686-.171874 0-.329426-.064453-.472655-.1933589C.071615 18.9276892 0 18.7629763 0 18.5624557V3.6953037c0-.2864579.078776-.5442698.236328-.7734357.157551-.2291659.365233-.4010405.623045-.5156237L7.390607.1289059C7.677065.0429686 7.963522 0 8.24998 0c.286458 0 .572915.0429686.859373.1289059l7.390608 2.6210875 7.30467-2.7070248C23.890568.0143227 23.976505 0 24.062443 0zM1.332028 3.6953037l.042969 13.8788731 6.187485-2.2773383V1.5468713L1.332028 3.6953037zm7.605451 11.6015348l6.874983 2.4062443V3.9531156L8.937479 1.5468713v13.7499672zm8.24998 2.4062443l6.230454-2.1484324-.042969-13.8788731-6.187485 2.2773383v13.7499672z" />
            </svg> -->
            <svg width="32px" height="21px" viewBox="0 0 32 21" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="step" transform="translate(1.000000, 0.000000)" fill="#D6D6D6" fill-rule="nonzero" stroke="#D6D6D6" stroke-width="0.3">
                  <path id="Shape" d="M22.4075271,2.15 L22.4075271,10.5 C22.4075271,10.859361 22.1134859,11.15 21.7516742,11.15 L11.2787635,11.15 L11.2787635,19.5 C11.2787635,19.859361 10.9847224,20.15 10.6229107,20.15 L0.505852888,20.15 C0.144041166,20.15 -0.15,19.859361 -0.15,19.5 C-0.15,19.140639 0.144041166,18.85 0.505852888,18.85 C4.61212232,18.85 4.61212232,18.85 8.58482936,18.85 L9.96705776,18.85 L9.96705776,10 L10.1170578,9.85 C10.2376242,9.85 10.2376242,9.85 10.7878664,9.85 C14.198488,9.85 14.198488,9.85 19.9736013,9.85 L21.0958213,9.85 L21.0958213,1.5 C21.0958213,1.14063901 21.3898625,0.85 21.7516742,0.85 C27.2761509,0.85 27.2761509,0.85 29.4432228,0.85 C29.9107449,0.85 30.1465873,1.11108357 30.1499641,1.49869325 C30.1525226,1.79236048 30.0232776,2.15 29.8453204,2.15 L22.4075271,2.15 Z" />
                </g>
              </g>
            </svg>
          </span>
          <p><span v-if="flat.floor == 0">BV</span><span v-else>Vån {{ flat.floor }}</span></p>
        </div>
      </div>
<!-- /FLOOR -->

              <div class="cell small-6 large-shrink">
                <div class="card-data">

                  
                  <span class="nav-icon">
                    <!-- <svg xmlns="http://www.w3.org/2000/svg"
                         width="28"
                         height="17">
                      <path
                        fill-rule="evenodd"
                        d="M6.187485 10.9999738c-.94531 0-1.754553-.3365875-2.427728-1.0097632-.673176-.6731757-1.009764-1.4824184-1.009764-2.4277286 0-.9453103.336588-1.7545529 1.009764-2.4277286.673175-.6731757 1.482418-1.0097632 2.427728-1.0097632.94531 0 1.754553.3365875 2.427729 1.0097632.673176.6731757 1.009763 1.4824183 1.009763 2.4277286 0 .9453102-.336587 1.7545529-1.009763 2.4277286s-1.482419 1.0097632-2.427729 1.0097632zm0-5.4999869c-.572915 0-1.059893.2005206-1.460934.6015611-.40104.4010404-.601561.8880189-.601561 1.460934 0 .5729151.200521 1.0598935.601561 1.460934.401041.4010405.888019.6015611 1.460934.6015611s1.059894-.2005206 1.460934-.6015611c.401041-.4010405.601561-.8880189.601561-1.460934 0-.5729151-.20052-1.0598936-.601561-1.460934-.40104-.4010405-.888019-.6015611-1.460934-.6015611zm16.499961-1.3749967c.859373 0 1.661454.2148432 2.406244.6445297.74479.4296865 1.332028 1.0169249 1.761715 1.7617145.429686.7447897.644529 1.5468713.644529 2.4062443v7.2187328c0 .0859373-.035807.1647129-.107421.2363275-.071615.0716147-.15039.1074217-.236328.1074217h-.687498c-.085937 0-.164713-.035807-.236328-.1074217-.071614-.0716146-.107421-.1503902-.107421-.2363275v-2.4062443H1.374997v2.4062443c0 .0859373-.035807.1647129-.107422.2363275-.071615.0716147-.15039.1074217-.236327.1074217H.343749c-.085937 0-.164713-.035807-.236327-.1074217C.035807 16.3209244 0 16.2421488 0 16.1562115V.3437492C0 .2578119.035807.1790363.107422.1074216.179036.035807.257812 0 .343749 0h.687499c.085937 0 .164712.035807.236327.1074216.071615.0716147.107422.1503903.107422.2363276v12.0312213h9.624977v-7.562482c0-.2005205.064453-.3652335.193359-.4941394.128906-.128906.293619-.1933589.494139-.1933589h10.999974zm3.437492 8.2499803V8.9374787c0-.9453103-.336588-1.7545529-1.009764-2.4277286-.673175-.6731757-1.482418-1.0097632-2.427728-1.0097632H12.37497v6.8749836h13.749968z" />
                    </svg> -->
                    <svg width="29px" height="22px" viewBox="0 0 29 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g id="room" transform="translate(0.150000, 1.000000)" fill="#ABABAB" fill-rule="nonzero" stroke="#ABABAB" stroke-width="0.9">
                          <path id="Shape" d="M27.85,14.5910417 L27.756852,5.48354167 L27.6363606,5.32375 L14.4300772,0 L14.3089848,0 L14.1878924,0 L0.970491448,5.324375 L0.85,5.47833333 L0.936237021,14.5895833 L1.01496211,14.6964583 L14.2491898,20 L14.4913746,20 L27.7643639,14.70125 L27.85,14.5910417 Z M27.3716399,14.2897917 L23.0805218,12.5685417 L23.2370706,5.7875 L23.1565426,5.68895833 L18.80593,3.94291667 L18.5637452,4.03791667 L18.3510072,10.6947917 L14.433683,9.14708333 L14.433683,0.467291667 L27.2156922,5.581875 L27.3716399,14.2897917 Z M22.7611143,12.4404167 L18.7290078,10.823125 L18.8819508,4.23604167 L22.9131559,5.85875 L22.7611143,12.4404167 Z M14.1332055,0.467291667 L14.1332055,9.18791667 L9.73661985,10.951875 L1.43322668,14.2858333 L1.37553502,5.58125 L14.1332055,0.467291667 Z M14.3705827,19.7070833 L1.65467854,14.59375 L2.79378846,14.1333333 L14.3393331,9.490625 L26.0699717,14.1702083 L27.1225442,14.5925 L14.3705827,19.7070833 Z M5.94669809,9.70854167 L5.71983763,9.61229167 L5.71983763,6.23270833 L5.77933216,6.13625 L10.5935815,4.16666667 L10.8279539,4.26291667 L10.8279539,7.6425 L10.7648536,7.73895833 L5.94669809,9.70854167 Z M6.02031506,6.29666667 L6.02031506,9.41708333 L10.5274764,7.57875 L10.5274764,4.45833333 L6.02031506,6.29666667 Z" />
                        </g>
                      </g>
                    </svg>
                  </span>
                  <p>{{ flat.rooms }} rum</p>
                </div>
              </div>

              <div class="cell small-6 large-shrink">
                <div class="card-data">
                  <span class="nav-icon">
                    <svg xmlns="http://www.w3.org/2000/svg"
                         width="28"
                         height="20">
                      <path
                        fill-rule="evenodd"
                        d="M26.235807.1250426c.372395 0 .69466.1360676.966795.4082022.272134.2721345.408202.5943994.408202.9667945V18c0 .3723952-.136068.69466-.408202.9667946-.272135.2721345-.5944.4082021-.966795.4082021H1.485866c-.372395 0-.69466-.1360676-.966794-.4082021C.246937 18.69466.11087 18.3723952.11087 18V1.5000393c0-.3723951.136067-.69466.408202-.9667945.272134-.2721346.594399-.4082022.966794-.4082022h24.749941zm0 17.8749574V1.5000393H1.485866V18h24.749941zm-13.406218-5.4999869c-.085937 0-.164713-.035807-.236327-.1074216-.071615-.0716146-.107422-.1503903-.107422-.2363276v-.6874983c0-.0859373.035807-.164713.107422-.2363276.071614-.0716146.15039-.1074216.236327-.1074216h3.437492c.085937 0 .164713.035807.236328.1074216.071614.0716146.107421.1503903.107421.2363276v.6874983c0 .0859373-.035807.164713-.107421.2363276-.071615.0716146-.150391.1074216-.236328.1074216h-3.437492zm10.312476-1.3749967c.085937 0 .164713.035807.236327.1074216.071615.0716146.107422.1503903.107422.2363276v.6874983c0 .0859373-.035807.164713-.107422.2363276-.071614.0716146-.15039.1074216-.236327.1074216h-3.437492c-.085937 0-.164713-.035807-.236328-.1074216-.071614-.0716146-.107421-.1503903-.107421-.2363276v-.6874983c0-.0859373.035807-.164713.107421-.2363276.071615-.0716146.150391-.1074216.236328-.1074216h3.437492zM12.829589 8.3750229c-.085937 0-.164713-.0358069-.236327-.1074216-.071615-.0716146-.107422-.1503902-.107422-.2363275v-.6874984c0-.0859373.035807-.1647129.107422-.2363276.071614-.0716146.15039-.1074216.236327-.1074216h10.312476c.085937 0 .164713.035807.236327.1074216.071615.0716147.107422.1503903.107422.2363276v.6874984c0 .0859373-.035807.1647129-.107422.2363275-.071614.0716147-.15039.1074216-.236327.1074216H12.829589zM5.911637 9.835957c-.401041-.1145833-.723305-.3294266-.966795-.6445297-.243489-.3151032-.365233-.6588524-.365233-1.0312476 0-.4869778.164713-.8951799.494139-1.2246064.329427-.3294266.737629-.5084622 1.224607-.5371081v-.4296865c0-.0859373.035807-.1647129.107421-.2363276.071615-.0716146.150391-.1074216.236328-.1074216h.687498c.085938 0 .164713.035807.236328.1074216.071615.0716147.107422.1503903.107422.2363276v.4296865c.458332.0286459.859372.1718746 1.203122.4296864.085937.0572913.136067.128906.15039.2148433.014323.0859373-.021484.1718746-.107422.2578119l-.515623.5585924c-.085938.1145833-.207682.1289059-.365234.0429686s-.336587-.1289059-.537108-.1289059H6.384292c-.114583 0-.214843.035807-.30078.1074216-.085938.0716146-.128906.1647129-.128906.2792962 0 .1718746.10026.2864579.30078.3437492l1.804683.4726551c.401041.1145833.723306.3294265.966795.6445297.243489.3151032.365233.6588524.365233 1.0312476 0 .4869778-.164713.8951799-.494139 1.2246064-.329427.3294265-.737629.5084621-1.224606.5371081v.4296865c0 .0859373-.035807.1647129-.107422.2363276-.071615.0716146-.15039.1074216-.236328.1074216h-.687498c-.085937 0-.164713-.035807-.236328-.1074216-.071614-.0716147-.107421-.1503903-.107421-.2363276v-.4296865c-.458333-.028646-.859373-.1718746-1.203122-.4296865-.085938-.0572913-.136068-.1289059-.150391-.2148432-.014322-.0859373.021485-.1718746.107422-.2578119l.515624-.5585924c.085937-.1145833.207681-.1289059.365233-.0429686.157552.0859372.336588.1289059.537108.1289059h1.117185c.114584 0 .214843-.035807.300781-.1074216.085937-.0716147.128906-.164713.128906-.2792962 0-.1718746-.10026-.2864579-.300781-.3437492L5.911637 9.835957z" />
                    </svg>
                  </span>
                  <p>{{ flat.rent|currency }}/mån</p>
                </div>
              </div>

              <div class="cell small-6 large-shrink">
                <div class="card-data">
                  <span class="nav-icon">
                    <svg xmlns="http://www.w3.org/2000/svg"
                         width="25"
                         height="20">
                      <path
                        fill-rule="evenodd"
                        d="M24.062443 0c.171874 0 .329426.064453.472655.1933589.143228.128906.214843.2936189.214843.4941395v14.867152c0 .2864579-.078776.5442698-.236328.7734357-.157551.2291659-.365233.4010405-.623045.5156237l-6.531234 2.2773384c-.572915.1718746-1.145831.1718746-1.718746 0L8.24998 16.4999607.94531 19.2069855c-.085937.0286459-.171874.0429686-.257812.0429686-.171874 0-.329426-.064453-.472655-.1933589C.071615 18.9276892 0 18.7629763 0 18.5624557V3.6953037c0-.2864579.078776-.5442698.236328-.7734357.157551-.2291659.365233-.4010405.623045-.5156237L7.390607.1289059C7.677065.0429686 7.963522 0 8.24998 0c.286458 0 .572915.0429686.859373.1289059l7.390608 2.6210875 7.30467-2.7070248C23.890568.0143227 23.976505 0 24.062443 0zM1.332028 3.6953037l.042969 13.8788731 6.187485-2.2773383V1.5468713L1.332028 3.6953037zm7.605451 11.6015348l6.874983 2.4062443V3.9531156L8.937479 1.5468713v13.7499672zm8.24998 2.4062443l6.230454-2.1484324-.042969-13.8788731-6.187485 2.2773383v13.7499672z" />
                    </svg>
                  </span>
                  <p>{{ flat.size }} m<sup>2</sup></p>
                </div>
              </div>

              <div class="cell small-12 medium-7">
                <Tags :details="flat.details" class="matchtags" />
                <!-- <div class="tag-wrap">
                  <span class="card-tag">Badkar</span>
                  <span class="card-tag">Badkar</span>
                  <span class="card-tag">Badkar</span>
                  <span class="card-tag">Badkar</span>
                  <div class="clear" />
                </div> -->

                <!-- <pre>{{ flat }}</pre> -->
              </div>

              <div class="cell small-12 medium-5" style="display: grid;padding-right:12px;margin-bottom:20px">
                <!-- <button class="button right" @click.prevent="showAd(ad.id)">
                  Visa annonsen
                </button> -->
                <router-link
                             class="button"
                             target="_blank"
                             :to="{ name: 'ad', params: { id: ad.id } }"
                             style="align-self:center;justify-self:right;text-decoration:none;">
                  Visa annons
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <div v-if="ad.flats && ad.flats.length == index+1"
             class="cell small-12 details">
          <!-- <router-link tag="button"
                       class="button"
                       :to="{ name: 'ad', params: { id: ad.id } }">
            Visa annonsen
          </router-link> -->

          <!-- Write out if it's direktbyte or triangelbyte -->
          <!-- <h3>{{ $t('match.'+match.depth) }}</h3> -->

          <!--
          <template v-if="ad.type == 12">
            <p>Bostäderna på {{ ad.flats[0].street }} och {{ ad.flats[1].street }} innehas av följande person:</p>
          </template>
          <template v-else>
            <p>Bostaden på {{ ad.flats[0].street }} innehas av följande person:</p>
          </template> -->

          <!-- TODO: Style the contacts -->
          <!-- The contact details of the owner of the match -->
          <!-- <div class="grid-x margin-x bbtable">
            <div class="cell small-4">
              Namn
            </div>
            <div class="cell small-4">
              Telefon
            </div>
            <div class="cell small-4">
              Epost
            </div>
            <div class="cell small-4">
              {{ match.owner.firstname }} {{ match.owner.lastname }}
            </div>
            <div class="cell small-4">
              {{ match.owner.phone }}
            </div>
            <div class="cell small-4">
              <a :href="'mailto:'+match.owner.email">{{ match.owner.email }}</a>
            </div>
          </div> -->

          <template v-if="match.depth == 'triangle'">
            <div class="triangleinfo">
              <p>
                Följande personer har tackat ja till din bostad och möjliggör därigenom ett <strong>triangelbyte</strong>: <!--
                Du kan byta din bostad mot <span v-for="(f) in ad.flats" :key="f.id">{{ f.street }} {{ f.street_number }} <span v-if="ad.flats.length > 1 && !ad.flats.lenght == index+1 "> och </span></span> om någon av följande personer accepterar din bostad som byte:
                -->
              </p>
            </div>
            <!-- <div class="grid-x margin-x bbtable">
              <div class="cell small-3">
                Annons
              </div>
              <div class="cell small-3">
                Namn
              </div>
              <div class="cell small-3">
                Telefon
              </div>
              <div class="cell small-3">
                Epost
              </div>
            </div> -->
            <div class="bbtable">
              <div v-for="(contact,index) in match.from_ad_ids"
                   :key="index"
                   class="grid-x margin-x">
                <template v-if="index === 0">
                  <div class="cell small-4 title">
                    Namn
                  </div>
                  <div class="cell small-2 title">
                    Telefon
                  </div>
                  <div class="cell small-4 title">
                    Epost
                  </div>

                  <div class="cell small-2 title" style="text-align:right;">
                    Annons
                  </div>
                </template>
                <!-- <div v-for="(contact,index) in match.from_ad_ids" :key="index" class="cell small-12"> -->
                <!-- <div class="grid-x"> -->

                <div class="cell small-12 medium-4">
                  {{ contact.contact.firstname }}  {{ contact.contact.lastname }}
                </div>
                <div class="cell small-12 medium-2">
                  {{ contact.contact.phone }}
                </div>
                <div class="cell small-12 medium-4">
                  <a :href="'mailto:' + contact.contact.email">{{ contact.contact.email }}</a>
                </div>

                <div class="cell small-12 medium-2">
                  <!-- <button class="button" style="padding:5px 10px;" @click.prevent="showAd(contact.id)">
                    Visa
                  </button> -->

                 <router-link
                               class="button"
                               target="_blank"
                               :to="{ name: 'ad', params: { id: contact.id } }"
                               style="text-decoration:none;padding:5px 10px;background-color:var(--color-secondary);float:right;margin-right:10px;    font-size: 12px;
    padding: 2px;padding-left:8px;padding-right:8px;
    border-radius: 4px">
                    {{ (contact && contact.details && contact.details.flats && contact.details.flats[0] && contact.details.flats[0].street && contact.details.flats[0].street_number ) ? `${contact.details.flats[0].street} ${contact.details.flats[0].street_number}` :  (contact.address ? contact.address :  'Visa annons')}}
                  </router-link>
                </div>
              <!-- </div> -->
              </div>
            </div>
          </template>

          <template v-if="match.depth == 'direct'">
            <!--
            <p>Du kan byta direkt med {{ match.from_ad_ids[0].contact.firstname }}</p>
            <ul>
              <div v-for="(contact,index) in match.from_ad_ids" :key="index">
                <li>Annons: {{ contact.id }}</li>
                <li>Namn: {{ contact.contact.firstname }} {{ contact.contact.lastname }}</li>
                <li v-if="contact.contact.email">
                  Epost: {{ contact.contact.email }}
                </li>
                <li v-if="contact.contact.phone">
                  Telefon: {{ contact.contact.phone }}
                </li>
              </div>
            </ul>
            -->
          </template>
        </div>
      </div>
    </article><!-- Match list item : END -->
    <article v-else>
      <div class="cell small-12 medium-shrink">
        <!-- <div class="image-wrap"> -->
        <!-- <h1>INTE KLAR</h1> -->
        <!-- <div style="padding-top:200px;position:relative"> -->
        <Preloader style="background-color:#ffffff;" />
        <!-- </div> -->
        <!-- </div> -->
      </div>
    </article>
  </div>
</template>

<script>
import AdService from '@/services/AdService.js'
import Preloader from '@/components/Preloader.vue'
import Tags from '@/components/Tags.vue'
import { mapGetters } from 'vuex'
import Ad from '@/views/Ad.vue'

export default {
  components: {
    Preloader,
    Tags,
    Ad
  },
  props: {
    match: {
      type: Object,
      required: true
    },
    adid: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isReady: false,
      ad: false
    }
  },
  computed: {
    ...mapGetters([

      'adDetails',

    ]),
  },
  watch: {
    adDetails() {
      if (this.adDetails == true) {
        this.$store.commit('SET_PROSPECT_MODAL', true)
      } else {
        this.$store.commit('SET_PROSPECT_MODAL', false)
      }
    },
  },
  mounted() {
    const adLoaded = AdService.getAd(this.adid)
      .then(response => {
        this.ad = response.data.data

        // this.ad = response.data.data.flats[0]
        // this.center = {
        //   lat: parseFloat(response.data.data.lat),
        //   lng: parseFloat(response.data.data.lng)
        // }
        // this.adLoaded = true
        this.isReady = true
      })
      .catch(error => {
        this.error = error
        this.$router.push({ name: '404' })
      })
    // The app preloader covers the page until every match has loaded, so the
    // list appears complete instead of each item spinning on its own.
    this.$store.dispatch('holdPreloader', adLoaded)
  },
  methods: {

    closeModal() {
      this.$store.commit('SET_AD_DETAILS', false)
    },

    showAd(id) {
      // this.adDetails = id
      this.$store.commit('SET_AD_DETAILS', id)
    },
    noimage(event) {
      event.target.src = '/img/bild_saknas.jpg'
    },
    url(photo) {
      let provider = photo.provider
      let base_url = ''
      let full_url = ''
      let card_url = ''
      if (provider == 's3') {
        full_url =
          'https://bytbostad.se/bilder/large/' + photo.img_url + '.jpg'
        base_url =
          'https://bytbostad.se/bilder/square/' + photo.img_url + '.jpg'
        card_url =
          'https://bytbostad.se/bilder/card/' + photo.img_url + '.jpg'
      } else if (provider == 'local') {
        base_url = 'https://bytbostad.se/slir/w250-c1x1/upload/' + photo.img_url
        full_url = 'https://bytbostad.se/slir/w1200/upload/' + photo.img_url
        card_url = 'https://bytbostad.se/slir/w800-c16x9/upload/' + photo.img_url
      }
      return { square: base_url, full: full_url, card: card_url }
    }
  }
}
</script>

<style scoped>

.triangleinfo{
      background-color: rgba(100, 188, 178, 0.2);
    padding: 10px;
    color: #5b5b5b;
}
.triangleinfo p{
  text-align: center;
}
.adModal{
  left:0;
}

.adModal #page-wrap, .adModal .page-wrap{
  margin-top: 0 !important;
}
.hidden{
  /* border:red solid 4px; */
}

.hiddeninfo{
  background-color:#ffb95c;
  padding:10px;
}
.hiddeninfo p, .hiddeninfo a{
  color:#1a1a1a;
}

.hiddeninfo p{
  text-align: center;
}

.details{
  /* background-color: red; */
}

.bbtable .cell{
/* border: 1px solid black; */
border-bottom:1px solid #F6F7F9;
  padding:5px;
margin-bottom:5px;
}
.bbtable .cell.title{
  color: #ABABAB;
  border-top:1px solid #F6F7F9;

}
</style>
